module.exports = __webpack_public_path__ + "static/img/Homev3.6339813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/Homev3.png
// module id = 5ewK
// module chunks = 0